export const SPAN_SCOPE = {
    REPORT_SCOPE: 'REPORT_SCOPE',
    CHAT_AGENT_SCOPE: 'CHAT_AGENT_SCOPE',
};
